import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: ${tokens.spacing.verticalXlarge};
  padding-right: ${tokens.spacing.horizontalLarge};
  padding-bottom: ${tokens.spacing.verticalMedium};
  padding-left: ${tokens.spacing.horizontalLarge};
`

export const Image = styled.img`
  display: block;
  height: 184px;
`

export const Text = styled.p`
  flex: 1;
  color: ${tokens.colors.dark5};
  line-height: ${tokens.lineHeight.medium}%;
  font-size: ${tokens.fontSize.medium};
  text-align: center;
  margin-bottom: ${tokens.spacing.verticalXlarge};
  margin-top: ${tokens.spacing.verticalMedium};
`
